export enum MobileAppsMessages {
    LOGOUT = "LOGOUT",
    SWITCH_ACCOUNT = "SWITCH_ACCOUNT",
    MORE_ACCOUNTS = "MORE_ACCOUNTS",
    OPEN_TABLET_SETTINGS = "OPEN_TABLET_SETTINGS",
    CLOSE_TABLET_SETTINGS = "CLOSE_TABLET_SETTINGS",
    NAVIGATE = "NAVIGATE",
    SCAN_QR_CODE = "SCAN_QR_CODE",
}

// Allowed navigation routes that native apps can navigate to
export const ALLOWED_NAVIGATION_ROUTES = ["/", "/settings/profile", "/settings/tabletApp"] as const;

// Dynamic routes with path parameters, e.g. purchases/:purchaseId/:itemId
export type AllowedDynamicRoute = `purchases/${string}/${string}`;

export type AllowedNavigationRoute = typeof ALLOWED_NAVIGATION_ROUTES[number] | AllowedDynamicRoute;

export type MobileAppsMessage =
    | { type: MobileAppsMessages.LOGOUT }
    | {
          type: MobileAppsMessages.SWITCH_ACCOUNT;
          payload: { delegatorId: string };
      }
    | { type: MobileAppsMessages.MORE_ACCOUNTS }
    | { type: MobileAppsMessages.OPEN_TABLET_SETTINGS }
    | { type: MobileAppsMessages.CLOSE_TABLET_SETTINGS }
    | {
          type: MobileAppsMessages.NAVIGATE;
          payload: { to: AllowedNavigationRoute; params?: string | Record<string, unknown> };
      }
    | { type: MobileAppsMessages.SCAN_QR_CODE };

export enum XolaMobileApp {
    XolaTablet = "XolaTablet",
    XolaPhone = "XolaPhone",
    XolaRedemption = "XolaRedemption",
    XolaKiosk = "XolaKiosk",
}
